import React from 'react';
import { Link, useParams } from 'react-router-dom';

import AnythingDetails from 'src/Components/Anything/AnythingDetails';
import AnythingsList from 'src/Components/Anything/AnythingsList';
import AnythingEdit from 'src/Components/Anything/AnythingEdit';

export function AnythingView(props) {
  const { id } = useParams();

  return (
    <div {...props}>
      <Link
        style={{
          float: 'right',
        }}
        to={`/anythings/${id}/edit`}
      >
        Edit
      </Link>
      <h1>Anything</h1>
      <AnythingDetails id={id} />
    </div>
  );
}

export function AnythingsView({ ...rest }) {
  return (
    <div {...rest}>
      <h1>Anythings</h1>
      <br />
      <AnythingsList />
    </div>
  );
}

export function AnythingEditView(props) {
  const { id } = useParams();

  return (
    <div {...props}>
      <h1>Edit Anything</h1>
      <AnythingEdit id={id} />
    </div>
  );
}
